import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';
import { ceil } from 'lodash';

export default {
  name: 'options-control',

  props: [
    'quiz',
    'answers',
  ],

  data() {
    return {
      isLoadingSubmit: false,
    };
  },

  computed: {
    ...mapGetters({
      cat: 'getCatCard',
      catPage: 'getCatPage',
      catQuizStartTime: 'getCatQuizStartTime',
      catQuizResult: 'getCatQuizResult',
      catPagesId: 'getCatPagesId',
      routeParams: 'getRouteParams',
      selectedOption: 'getSelectedOption',
      isPrime: 'isPrime',
      isUserLicence: 'isUserLicence',
      isSubscriptionUser: 'isSubscriptionUser',
      isPremiumSchool: 'isPremiumSchool',
    }),
  },

  methods: {
    ...mapActions([
      'saveCatQuizResult',
      'endQuizMonitoring',
      'fetchPageQuizResultCache',
      'fetchPageAnswerStatistics',
    ]),

    handleCatQuizSubmit() {
      const duration = ceil((new Date().getTime() - this.catQuizStartTime) / 1000) || 0;

      if (duration <= this.quizSubmitLimitTime) {
        // eslint-disable-next-line
          alert('3초만 기다려주세요. 진지하게 문제를 해결해 주세요.');
        return;
      }

      this.isLoadingSubmit = true;
      const { catId } = this.routeParams;
      const pageId = Number(this.routeParams.page) - 1;
      const data = {
        page_id: this.catPagesId,
        answer_id: this.selectedOption.id || '',
        value: this.selectedOption.value || '',
        duration,
        is_prime: this.isPrime,
        is_user_licence: this.isUserLicence,
        is_school_licence: this.isPremiumSchool,
      };

      this.saveCatQuizResult({ data, catId, pageId })
        .then(() => {
          if (this.isSubscriptionUser) {
            Vue.nextTick()
              .then(() => document.getElementById('quiz-result-focus').scrollIntoView(true));
          }

          this.isLoadingSubmit = false;

          this.endQuizMonitoring({
            cat: this.cat,
            catPage: this.catPage,
            quizResult: this.catQuizResult,
          });
        })
        .then(() => this.fetchPageQuizResultCache({ pageId: this.catPage.id }))
        .then(() => {
          if (this.catPage.page_type.name === 'multiple_choice') {
            this.fetchPageAnswerStatistics({ pageId: this.catPage.id });
          }
        });
    },
  },
};
